import React from 'react';

import { FolderOpen } from 'lucide-react';
import DocumentRow from './DocumentRow';
import DocumentCard from './DocumentCard';

const DocumentDisplay = ({ documents, categories, onView, onDownload, onPrint, onDelete, loading, formatFileSize, formatDate, getStatusBadge, viewMode, onPublish, publishingDoc, printingDocId }) => {
  if (loading) {
    return (
      <div className="p-12 text-center">
        <div className="w-12 h-12 border-3 border-amber-200 border-t-amber-600 rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-gray-500 text-sm">Chargement des documents...</p>
      </div>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <div className="p-12 text-center">
        <FolderOpen className="w-16 h-16 mx-auto mb-4 text-gray-300" />
        <p className="text-gray-500 font-medium">Aucun document dans cette entité</p>
        <p className="text-sm text-gray-400 mt-1">Uploadez votre premier document</p>
      </div>
    );
  }

  if (viewMode === 'grid') {
    return (
      <div className="p-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {documents.map(doc => (
          <DocumentCard key={doc.id} doc={doc} categories={categories} onView={onView} onDownload={onDownload} onPrint={onPrint} onDelete={onDelete} formatFileSize={formatFileSize} formatDate={formatDate} getStatusBadge={getStatusBadge} printingDocId={printingDocId} />
        ))}
      </div>
    );
  }

  return (
    <div>
      {documents.map(doc => (
        <DocumentRow key={doc.id} doc={doc} categories={categories} onView={onView} onDownload={onDownload} onPrint={onPrint} onDelete={onDelete} formatFileSize={formatFileSize} formatDate={formatDate} getStatusBadge={getStatusBadge} onPublish={onPublish} publishingDoc={publishingDoc} printingDocId={printingDocId} />
      ))}
    </div>
  );
};

// === ADVANCED SEARCH BAR ===

export default DocumentDisplay;
